import React from "react";
import { ReactComponent as LinkIcon } from "../../assets/icons/table/link.svg";
import { IOrder } from "../../types/order.type";
import { formatDate, formatTime } from "../../utils/formatDate";
import PaymentStatusComponent from "../PaymentStatus/PaymentStatus";
import styles from "./styles.module.scss";

interface Props {
  orders: IOrder[];
  onPressLink: (id: number | string) => void;
}

const NewOrdersTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Дата</th>
          <th>Контактна інформація</th>
          <th>Замовлення</th>
          <th>Статус</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.orders &&
          props.orders.map((user, index) => (
            <tr key={user.id}>
              <td>
                <div className={styles.userInfo}>
                  <div className={styles.dateContainer}>
                    <span>{formatDate(user.createdAt)}</span>
                    <span>{formatTime(user.createdAt)}</span>
                  </div>
                </div>
              </td>
              <td className={styles.role}>
                <div className={styles.nameContainer}>
                  <span className={styles.name}>{user.client.fullName}</span>
                  <span className={styles.email}>{user.client.phone}</span>

                  <span className={styles.email}>{user.client.email}</span>
                </div>
              </td>
              <td className={styles.role}>
                {user.items.map((item) => (
                  <div className={styles.nameContainer}>
                    <span className={styles.email}>
                      {item.product.name} - {item.quantity}
                    </span>
                  </div>
                ))}
              </td>
              <td>
                <PaymentStatusComponent status={user.status} />
              </td>
              <td>
                <div className={styles.actions}>
                  <button
                    className={styles.editBtn}
                    onClick={() => {
                      props.onPressLink(user.id);
                    }}
                  >
                    <LinkIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default NewOrdersTable;
